import React, { useEffect } from "react"
// import Image from "next/image"
// import imgMiddle from "assets/img/image/img_about-middle.png"
import imgMiddle from "assets/img/image/img_about-showroom-export.jpeg"

//Utils
import { useRouter } from "next/router"
import {
  useIsomorphicLayoutEffect,
  useScrollAnim,
} from "@components/hooks/hooks"
import { Image, Link } from "@components/anti"

const ExportHistory = ({ locale, locales }) => {
  //Utils
  const Router = useRouter()

  const [trigger, anim] = useScrollAnim()

  // useIsomorphicLayoutEffect(() => {
  //   document.documentElement.classList.add("enable-sticky")
  // }, [])
  //React Operations ******************************************************************** //

  return (
    <section className={`sc-export-history`} ref={trigger}>
      <div className={`container`}>
        <div className={`row`}>
          <div className={`col-12 col-md-7 wrapper-img ${anim(1)}`}>
            <Image
              src={imgMiddle}
              alt="about-middle"
              placeholder="blur"
              className="img-middle-about fadeInUp"
              ratio="r-1-1"
            />
          </div>
          <div className={`col-12 col-md-6 col-content ${anim(1)}`}>
            <div className="wrapper-content">
              <h1 className={`title ${anim(3)}`}>
                Our Showroom & Export History
              </h1>
              <h6 className={`text ${anim(4)}`}>
                With a span of 28 years we have been exporting our product all
                over the world with the EU as the main destination; from
                retailers to conceptual importers.
              </h6>
              <h6 className="text">
                Lately our portfolio has expanded to global co-working space,
                boutique hotel group, restaurant groups in Indonesia & overseas.
              </h6>
              <h6 className="text">
                For overseas inquiry please reach us at:
                <br />
                <Link
                  className="hover-underline inverse"
                  to="mailto:hello@nagarey.com"
                >
                  hello@nagarey.com
                </Link>
              </h6>
              <h6 className="text">
                <Link className="hover-underline inverse" to="/our-store">
                  Visit our showroom
                </Link>{" "}
                and see the collection in person.
              </h6>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ExportHistory
